import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-date/jb-date.css.ts
var jb_date_css_default = i`time{font-family:var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);font-style:normal;font-weight:var(--theme-font-light-weight, 300)}time{font-size:var(--theme-typo-p-mini-desktop-fontsize, 0.813rem);line-height:var(--theme-typo-p-mini-desktop-lineheight, 1.25rem)}time{color:rgb(var(--theme-color-royal-blue, 20 30 85));display:flex;gap:var(--gap, 4px);opacity:var(--text-opacity, 1)}`;

export {
  jb_date_css_default
};
